import { render, staticRenderFns } from "./AppraiserValuationWrapper.vue?vue&type=template&id=01f952f2&"
import script from "./AppraiserValuationWrapper.vue?vue&type=script&lang=ts&"
export * from "./AppraiserValuationWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports